<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box american-credit-partner">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<!-- <h1>Let’s join forces</h1> -->
              <h1>Want to partner with American Credit®? Let's join forces.</h1>
							<button @click="this.window.location.href='/partner'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button>
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Partner with American Credit. Help your clients get the financing they need. Deliver an incredible customer experience. Generate incremental revenue. </span><span style="color: #5456ff; font-weight: 700;"><a href="/partner">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="american-credit-partner-main-img" src="../assets/imgs/american_credit_business_loan_partner.png" alt="american credit business loan partner"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%;">
      <div class="row user-feedback partner-with-leaders">
        <div class="col-2 col-lg-4" style="background-color: #00234d;"></div>
        <div class="col-10 col-lg-8" style="background-color: #f6f9ff;"></div>
        <div class="container row user-feedback-content">
          <div class="col-12 col-lg-5 offset-lg-1 user-feedback-content-left">
            <img src="../assets/imgs/partner_with_leaders.png" alt="american credit partner with leaders"/>
          </div>
          <div class="col-10 offset-2 col-lg-5 offset-lg-0 user-feedback-content-right">
            <h2 class="partner-with-leaders-title">Partnered with leaders from many industries</h2>
            <p class="partner-with-leaders-text">To ensure our customers get the secured business loans they need quickly and affordably, American Credit partners with leaders from a diverse range of industries. By combining their skills and technologies with our financial data and risk management expertise we can offer customers a wide scope of asset backed loans, invoice factoring loans, and other cash flow loans on a fair, responsible and affordable basis.</p>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform how-works">
        <h2 class="text-center partners-title">Our key finance, technology and security partners include:</h2>
        <!-- <h6 class="text-center invest-with-us-text">American Credit opens new avenues for lending to businesses. Especially those who have passable, but less-than-prime, credit scores and to whom banks won’t loan. We combine local, personal service with advanced data science and financial expertise to assess risk quickly—and to accurately determine the success of a business and ability to repay.</h6> -->
        <div class="row">
          <div class="col-12 col-lg-10 offset-lg-1">
            <div class="row partner-items">
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="partner-item">
                  <img src="../assets/imgs/logo-experian.svg" alt="american credit partner experian">
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="partner-item">
                  <img src="../assets/imgs/plaid_logo.svg" alt="american credit partner plaid">
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="partner-item">
                  <img src="../assets/imgs/ocrolus_logo.png" alt="american credit partner ocrolus">
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="partner-item">
                  <img src="../assets/imgs/aws-logo.png" alt="american credit partner aws">
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="partner-item">
                  <img src="../assets/imgs/twilio-logo-red.png" alt="american credit partner twilio"> 
                </div>
              </div>
              <div class="col-6 col-lg-2 partner-item-wrapper">
                <div class="partner-item">
                  <img src="../assets/imgs/logo_hubspot.png" alt="american credit partner hubspot">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-10 offset-lg-1" style="border-bottom: 1px solid #dfdfdf;"></div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform referral-program">
        <div class="row referral-program-inner">
          <div class="col-12 col-lg-5 offset-lg-1 referral-program-inner-left">
            <h2>Referral program</h2>
            <p>Introduce American Credit to your clients and benefit from our generous referral program.<br>Grow your business, get perks, and help your customers. We are always looking for new partners to bring financial power to small businesses.</p>
            <div class="referral-program-inner-left-why">
              <h4>Why become a referral partner?</h4>
              <ul>
                <li>We empower ISOs, brokers, and affiliates to effectively serve clients from start to finish</li>
                <li>We offer a flexible, revolving credit solution that clients want at competitive rates</li>
                <li>We achieve an 80%+ approval rate on qualified leads in general</li>
              </ul>
            </div>
          </div>
          <div class="col-12 col-lg-5 referral-program-inner-right">
            <img src="../assets/imgs/American_Credit_Business_Loans_Referral_Program.png" alt="American Credit Business Loans Referral Program">
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform contact-us">
        <div class="row">
          <div class="col-12 col-lg-5 offset-lg-1 contact-us-left">
            <h4 class="contact-us-title">Drop us a line</h4>
            <p class="contact-us-text">Whether you want to start a partnership or become a broker, we are happy to work with you. Please feel free to send us a message.</p>
            <el-form class="row" :label-width="'0'" :model="step2Form" :rules="rules" ref="step2Form">
              <el-form-item class="col-6" prop="firstName" required>
                <el-input type="text" placeholder="First Name*" v-model="step2Form.firstName"></el-input>
              </el-form-item>
              <el-form-item class="col-6" prop="lastName" required>
                <el-input type="text" placeholder="Last Name*" v-model="step2Form.lastName"></el-input>
              </el-form-item>
              <el-form-item class="col-6" prop="email" required>
                <el-input type="text" placeholder="Email*" v-model="step2Form.email"></el-input>
              </el-form-item>
              <el-form-item class="col-6" prop="phone" required>
                <el-input type="tel" placeholder="Phone*" v-model="step2Form.phone"></el-input>
              </el-form-item>
              <el-form-item class="col-12" prop="content">
                <el-input type="textarea" placeholder="Message content." v-model="step2Form.content"></el-input>
              </el-form-item>
              <br />
              <div class="col-12">
                <el-button
                  type="primary"
                  :loading="isLoading"
                  class="rounded-pill font-weight-bold"
                  @click="submitForm"
                  style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 54px; width: 190px; border-radius: 27px; border: none; margin-top: 36px;"
                >Send Message</el-button>
                <el-form-item label prop></el-form-item>
              </div>
            </el-form>
          </div>
          <div class="col-12 col-lg-5 contact-us-right">
            <h4 class="contact-us-title">Get in touch with us</h4>
            <p class="contact-us-text">We understand. Sometimes you just want to get a few answers and move on with business.</p>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_location.png" alt="american credit location">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Address</h5>
                <p style="white-space: nowrap;">2100 Geng Road, Suite 210<br /> Palo Alto, CA 94303</p>
              </div>
            </div>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_phone.png" alt="american credit phone">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Phone</h5>
                <p><a href="tel:1855-904-0188">855-904-0188</a></p>
              </div>
            </div>
            <div class="row contact-card">
              <div class="col-1 contact-card-img">
                <img src="../assets/imgs/american_credit_email.png" alt="american credit email">
              </div>
              <div class="col-6 contact-card-text">
                <h5>Email</h5>
                <p><a href="mailto:info@amcredit.com">info@amcredit.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="width: 100%; background: white;">
      <div class="container platform trust-us">
        <div class="row trust-us-box">
          <div class="col-12 col-lg-5 offset-lg-1 trust-us-inner-left">
            <div>
              <p class="trust-us-title">American Credit: The difference you can trust</p>
              <p class="trust-us-text" style="color: #686868; font-weight: 300;"><span style="font-weight: 700;">You work hard. We work hard. We share the same ethic.</span> That’s why we go the extra mile to look at your situation and see if we can help. Unlike some business credit lenders who focus on FICO scores, we look at your business as a whole.</p>
              <br />
              <div class="trust-us-button">
                <button @click="this.window.location.href='/get-start'">Apply Now</button>
                <p><span style="color: #3c3c3c; font-weight: 700;"><a href="contact-us">Feel free to contact us <i class="fa fa-long-arrow-right" style="color: #5456ff;"></i></a></span></p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 trust-us-inner-right">
            <img src="../assets/imgs/American_Credit_Business_loans_the_Difference_You_can_Trust.png" alt="American Credit Business loans the Difference You can Trust"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as types from "../vuex/types";
import api from "../vuex/api/index";

export default {
  data() {
    return {
      isLoading: false,
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        businessName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      },
      rules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    submitForm() {
      this.$refs['step2Form'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          var _this = this;
          api
            .postForm("/common/sysfeedback/mgxyPartner.ht", {
              tokenId: _this.userInfo.token,
              firstName: _this.step2Form.firstName,
              lastName: _this.step2Form.lastName,
              email: _this.step2Form.email,
              phone: _this.step2Form.phone,
              content: "Partnership message: " + _this.step2Form.content
            })
            .then(res => {
              this.$router.push({
                path: `/`,
                query: {}
              });
            });
        } else {
          console.log('error submit!!');
        }
      });
    }
  },
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Partner Programs & Referral Programs | American Credit";
    meta.content = "Work alongside American Creditt to empower business owners with quick & simple financing options. We love helping people acheive the American Dream. Call us!";
    keywords.content = "american credit partners, Experian, Plaid, Ocrolus, Salesforce, IBM, SBA, American Credit, amcredit";
  }
};
</script>

<style scoped lang="scss">
  @import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";
  
  .american-credit-partner {
    min-height: 590px !important;
    .business-loan-box-left-inner {
      margin-top: 100px !important;
      h1 {
        font-size: 58px !important;
      }
    }
    .american-credit-partner-main-img {
      width: 680px !important;
      margin-top: 70px !important;
    }
  }

  .partner-with-leaders-title {
    font-family: Biotif;
    color: #272727;
    font-size: 36px;
    font-weight: 700;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .partner-with-leaders {
    height: 600px;
  }

  .partner-with-leaders-text {
    color: #808080;
    font-size: 18px;
    font-weight: 300;
    line-height: 28px;
  }

  .partners-title {
    width: 627px;
    margin: auto;
  }
  .partner-items {
    margin-bottom: 120px;
    .partner-item-wrapper {
      padding-left: 8px;
      padding-right: 8px;
      margin-top: 30px;
      .partner-item {
        border-radius: 3px;
        background-color: #ffffff;
        box-shadow: 2px 4px 25px 0px rgba(222, 222, 222, 0.75);
        height: 100px;
        text-align: center;
        img {
          margin-top: 25px;
          height: 50%;
          width: auto;
          object-fit: contain;
          max-width: 100%;
        }
      }
    }
  }

  .referral-program {
    margin-top: 110px;
    margin-bottom: 140px;
    .referral-program-inner {
      .referral-program-inner-left {
        h2 {
          font-family: Biotif;
          color: #272727;
          font-size: 36px;
          font-weight: 700;
        }
        p {
          color: #686868;
          font-size: 17px;
          font-weight: 300;
          line-height: 28px;
        }
        .referral-program-inner-left-why {
          border-left: 1px solid #dadada;
          padding-left: 70px;
          margin-top: 50px;
          h4 {
            font-family: Montserrat;
            color: #272727;
            font-size: 22px;
            font-weight: 600;
            line-height: 26px;
            margin-bottom: 30px;
          }
          ul {
            padding-left: 28px;
            li {
              display: list-item;
              list-style-image: url(../assets/imgs/list_style_icon.png);
              margin-bottom: 10px;
              padding-left: 5px;
              color: #686868;
              font-size: 18px;
              font-weight: 300;
              line-height: 28px;
            }
          }
        }
      }
      .referral-program-inner-right {
        img {
          width: 493px;
          height: auto;
          object-fit: contain;
          margin-top: 80px;
        }
      }
    }
  }

  .partners-user-feedback {
    height: 640px !important;
  }

  @media (max-width: 768px) {
    .american-credit-partner {
      min-height: 0 !important;
      .business-loan-box-left-inner {
        margin-top: 43px !important;
      }
      .american-credit-partner-main-img {
        width: 100% !important;
        margin-top: 0 !important;
        margin-bottom: 50px;
      }
    }

    .partner-with-leaders {
      height: 760px;
    }

    .partners-title {
      width: 100%;
    }

    .partner-items {
      margin-bottom: 60px;
    }

    .referral-program {
      margin-top: 60px;
      margin-bottom: 40px;
      .referral-program-inner {
        .referral-program-inner-right {
          img {
            width: 100%;
            margin-top: 40px;
          }
        }
      }
    }

    .partners-user-feedback {
      height: 780px !important;
    }
  }
  
</style>


// WEBPACK FOOTER //
// partners.vue?cf0b1ed0